import React from 'react';
import { useNavigate } from 'react-router-dom';

// Shared "back to listing" icon button — circular pill with a left
// arrow, sits at the head of a detail page. Hover lifts the colour to
// brand green. Replaces the mix of "← Briefs" text breadcrumbs,
// ghost text links and bordered pills that had drifted across pages.
//
// Props:
//   to        — destination route. Falls back to navigate(-1) when omitted.
//   label     — aria-label / title (defaults to "Back").
//   onClick   — optional override; receives the click event before
//               navigation. Useful for confirm-before-leave guards.
//   className — extra classes (e.g. "ml-4" for layout-specific spacing).
//
// Usage:
//   <BackIconButton to="/briefs" label="Back to briefs" />
//   <BackIconButton to={`/briefs/${briefId}`} label="Back to brief" />
//   <BackIconButton label="Go back" />   // history-relative

export default function BackIconButton({ to, label = 'Back', onClick, className = '' }) {
  const navigate = useNavigate();
  const handleClick = (e) => {
    if (typeof onClick === 'function') {
      onClick(e);
      if (e.defaultPrevented) return;
    }
    if (to) navigate(to);
    else navigate(-1);
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={label}
      title={label}
      className={`w-9 h-9 rounded-full border border-line text-[#51534A] hover:text-active-green hover:border-active-green transition-colors inline-flex items-center justify-center flex-shrink-0 ${className}`}
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M19 12H5" />
        <polyline points="12 19 5 12 12 5" />
      </svg>
    </button>
  );
}
